/**
 * pdfjs-dist 5.5+ `Page.getTextContent()` does `for await (const value of readableStream)` on the
 * stream returned from `streamTextContent()`. That requires `ReadableStream.prototype[Symbol.asyncIterator]`,
 * which is missing on older Safari / WebKit — runtime: `undefined is not a function` near readableStream.
 *
 * Install before any pdf.js code runs (import from `main.tsx` right after other polyfills).
 */
function installReadableStreamAsyncIterator(): void {
  if (typeof ReadableStream === 'undefined') return
  const proto = ReadableStream.prototype as unknown as {
    [Symbol.asyncIterator]?: () => AsyncGenerator<unknown, void, unknown>
  }
  if (typeof proto[Symbol.asyncIterator] === 'function') return

  proto[Symbol.asyncIterator] = async function* readableStreamAsyncIterator(this: ReadableStream) {
    const reader = this.getReader()
    try {
      for (;;) {
        const { done, value } = await reader.read()
        if (done) return
        yield value
      }
    } finally {
      try {
        reader.releaseLock()
      } catch {
        /* already released */
      }
    }
  }
}

installReadableStreamAsyncIterator()
